import React, { Component } from 'react'
import autoBind from 'react-autobind'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Container, Image, Segment, Header } from 'semantic-ui-react'
import FeelDataReportNoData from '../../../assets/images/FeelDataReportNoData.png'

class NoReports extends Component {
    constructor (props) {
        super(props)
        autoBind(this)
    }

    render () {
        return (
            <React.Fragment>
                <Container className='dashboard'>
                    <Segment className='no-reports'>
                        <Header as='h2'>
                            FEEL DATA REPORTS ARE NOT AVAILABLE
                        </Header>
                        <p>
                            {this.props.text}
                        </p>
                        <Image src={FeelDataReportNoData} alt={"feel_data_report_no_data"} centered/>
                    </Segment>
                </Container>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        currentReport: state.reports.currentReport,
        pid: state.profiles.profile.pid
    }
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NoReports))



// WEBPACK FOOTER //
// ./src/components/participant-feel-data-reports/no-reports/index.js